import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { FormatNumberPipe } from 'app/shared/pipes/format-number.pipe';
import { ChartComponentBase } from '../chart.types';

@Component({
  selector: 'chart-bar',
  templateUrl: './bar.component.html',
  styleUrls: ['./bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartBarComponent extends ChartComponentBase {
  @Input() horizontal = false;

  constructor(private readonly formatNumber: FormatNumberPipe) {
    super();
  }

  prepareChart(): void {
    if (this.isTimeSeries) {
      this.chartOptions = {
        colors: this.defaultColors,
        series: this.chartDef.series,
        plotOptions: {
          bar: {
            horizontal: this.horizontal,
          },
        },
        chart: {
          fontFamily: 'inherit',
          foreColor: 'inherit',
          width: '100%',
          height: this.height ? this.height : this.fillMode ? '96%' : 'auto',
          type: 'bar',
          stacked: true,
          animations: {
            enabled: false,
          },
          events: {
            dataPointSelection: (event, chart, options) => {
              this.dataPointSelection.emit(options);
            },
          },
        },
        markers: {
          size: 0,
        },
        dataLabels: {
          enabled: false,
          formatter: (val) => this.formatter(val),
          style: {
            colors: ['#304758'],
          },
        },
        xaxis: {
          categories: this.chartDef.rankedCategories,
        },
      };
    } else {
      this.chartOptions = {
        colors: this.defaultColors,
        series: this.chartDef.series,
        plotOptions: {
          bar: {
            horizontal: this.horizontal,
          },
        },
        chart: {
          fontFamily: 'inherit',
          foreColor: 'inherit',
          width: '100%',
          height: this.fillMode ? '96%' : 'auto',
          type: 'bar',
          stacked: true,
          animations: {
            enabled: false,
          },
          events: {
            dataPointSelection: (event, chart, options) => {
              this.dataPointSelection.emit(options);
            },
          },
        },
        markers: {
          size: 0,
        },
        dataLabels: {
          enabled: false,
          formatter: (val) => this.formatter(val),
          style: {
            colors: ['#304758'],
          },
        },
        stroke: {
          curve: 'straight',
          width: 2,
        },
        xaxis: {
          type: 'category',
          categories: this.chartDef.rankedCategories,
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
            formatter: (val) => this.formatter(val),
          },
        },
      };
    }
  }

  private formatter(val: any): string {
    if (Number.isNaN(Number(val))) {
      return val;
    }

    if (this.chartDef.formatting && this.chartDef.formatting?.type) {
      if (this.chartDef.formatting?.type == 'number') {
        return this.formatNumber.transform(val.toString(), 0);
      } else if (this.chartDef.formatting?.type == 'percent') {
        return this.formatNumber.transform(val.toString()) + '%';
      } else if (this.chartDef.formatting?.type == 'money') {
        return '$' + this.formatNumber.transform(val.toString());
      }
    } else {
      return this.formatNumber.transform(val.toString(), 0);
    }
  }
}
